/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GetAiTutorThumbsDownGated } from './getAiTutorThumbsDownGated';

export type GetAiTutorThumbsDownParams = {
  /**
   * Inclusive range start (ISO datetime)
   */
  from?: string;
  /**
   * Exclusive range end (ISO datetime)
   */
  to?: string;
  gated?: GetAiTutorThumbsDownGated;
  excludePasteHeavy?: boolean;
  excludeFirstTryPasses?: boolean;
  /**
   * Module ids to include. Empty means every module. Comma-separated in the query.
   */
  moduleIds?: string[];
  page?: number;
  pageSize?: number;
};
